import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/** @jsx jsx */
import { jsx } from '@emotion/core';
import * as React from 'react';
import splitStyles from '../system/split-styles';
import { useVariant } from '../VariantProvider';
var defaultElement = 'div';
/**
 * Box is the base component that everything builds from. It is responsible for processing all style props.
 */

export function Box(_ref) {
  var as = _ref.as,
      innerRef = _ref.innerRef,
      inline = _ref.inline,
      props = _objectWithoutPropertiesLoose(_ref, ["as", "innerRef", "inline"]);

  var Element = as || defaultElement;
  var variant = useVariant();
  return jsx(Element, _extends({
    ref: innerRef
  }, splitStyles(_objectSpread({
    display: inline ? 'inline-block' : 'block',
    variant: variant
  }, props))));
}